export default "__VITE_ASSET__BWWcfI88__"